import { trackClickedAttr } from '#/snippets/track-clicked.attributes';
import { trackClicked } from '#/utils/analytics/track/trackClicked';

export function trackClickedElement(el: Element) {
  const name = el.getAttribute(trackClickedAttr);
  if (!name) return null;

  const properties: Record<string, string> = {};

  const attributeNames = el
    .getAttributeNames()
    .filter((attr) => attr.startsWith(`${trackClickedAttr}-`));

  for (const attrName of attributeNames) {
    const value = el.getAttribute(attrName);
    if (value) properties[attrName.slice(trackClickedAttr.length + 1)] = value;
  }

  if (el.tagName === 'a') {
    const href = el.getAttribute('href');
    if (href) properties.url = href;
  }

  trackClicked(name, properties);
}
